import React from 'react';

export const ContactNewIcon = (props) => {
  const { className = '', style = {}, disabled = false, onClick } = props;
  return (
    <svg
      className={`custom-icon ${disabled ? 'disabled' : ''} ${className}`}
      onClick={disabled ? null : onClick}
      style={style}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_37363_8348)">
        <path d="M24.0002 23.4753C24.9931 23.4753 25.8584 23.1207 26.5676 22.4115C27.2768 21.7023 27.6314 20.8512 27.6314 19.8441C27.6314 18.837 27.2768 17.9859 26.5676 17.2767C25.8584 16.5675 25.0073 16.2129 24.0002 16.2129C22.9931 16.2129 22.142 16.5675 21.4328 17.2767C20.7236 17.9859 20.369 18.837 20.369 19.8441C20.369 20.8512 20.7236 21.7023 21.4328 22.4115C22.142 23.1207 22.9931 23.4753 24.0002 23.4753Z" />
        <path d="M24.0001 25.4895C26.1845 25.4895 27.9291 25.8866 29.2625 26.6951H29.2483C30.5816 27.5036 31.2483 28.5817 31.2483 29.9434V30.8653L31.1774 30.9363C29.3476 32.7661 26.8086 33.9008 24.0001 33.9008C21.1915 33.9008 18.6667 32.7661 16.8228 30.9363C16.7944 30.9079 16.7376 30.837 16.7376 30.837V29.9434C16.7376 28.5817 17.4043 27.4895 18.7376 26.6951C20.071 25.8866 21.8157 25.4895 24.0001 25.4895Z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.0001 10.666C16.6526 10.666 10.6667 16.6518 10.6667 23.9993C10.6667 31.3469 16.6526 37.3327 24.0001 37.3327C31.3476 37.3327 37.3334 31.3469 37.3334 23.9993C37.3334 16.6518 31.3476 10.666 24.0001 10.666ZM24.0001 34.8788C17.9859 34.8788 13.1206 30.0135 13.1206 23.9993C13.1206 17.9852 17.9859 13.1199 24.0001 13.1199C30.0143 13.1199 34.8795 17.9852 34.8795 23.9993C34.8795 30.0135 30.0143 34.8788 24.0001 34.8788Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_37363_8348">
          <rect width="32" height="32" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};

// Figma: new contact
